// COnstants
import { LocationSummaryWithinConstants } from "../../../constants/GeneralConstants";

// Components
import { PlainDropdown } from "../../../components/dropdown/Dropdown";
import Spinner from "../../../components/spinner/Spinner";

/**
 * Radius Selector
 */
function RadiusSelector({ onItemSelect, isLoading, title, className = "" }) {
  return (
    <div className={`d-flex align-items-center ${className}`}>
      {title && <h4>{title}</h4>}
      <PlainDropdown
        items={LocationSummaryWithinConstants}
        onItemSelect={onItemSelect}
        className="h4 border-0"
        textClassName="text-primary"
      />
      {isLoading && <Spinner className="spinner-border-sm mb-2 mx-1" />}
    </div>
  );
}

export default RadiusSelector;
